import {
  Modal,
  Form,
  Input,
  Button,
  Col,
  Row,
  notification,
  DatePicker,
  Select,
} from "antd";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import { create } from "../../../../../controllers/store/actions/commons/create-common-action";
import SelectCities from "../../Elements/Select-Cities";
import TextArea from "antd/es/input/TextArea";
import SelectRecognition from "../../Elements/Select-Recognize";
import SelectAccredited from "../../Elements/Select-Accredited";
import SelectStates from "../../Elements/Select-States";
import { useState } from "react";
import SelectKnowledgeArea from "../../Elements/Select-Knowledge-Area";
import SelectKnowledgeGran from "../../Elements/Select-Knowledge-Gran";
import SelectKnowledgeSpecialty from "../../Elements/Select-Knowledge-Specialty";
import { MaskedInput } from "antd-mask-input";
import SelectEntityDependency from "../../Elements/Select-Entity-Dependency";
import { Actor } from "../../../..";

interface Props {
  loading?: boolean;
  actorType?: any;
  visible: boolean;
  onCreated: () => void;
  onCancel: () => void;
}

const dispatch = store.dispatch;
const NewCommonModal = (Props: Props) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const createdCommonState = useSelector((state: any) => state.createdCommon);
  const [state, setState] = useState<any>();
  return (
    <Modal
      width={800}
      open={Props.visible}
      title={Props?.actorType?.actor || ""}
      okText={"Agregar"}
      cancelText="Cancelar"
      footer={null}
      onCancel={Props.onCancel}
    >
      <>
        {contextHolder}
        <Form
          form={form}
          layout="vertical"
          onFinish={async (formData: any) => {
            form.validateFields().then(async (values) => {
              await dispatch(
                create({
                  contact_name: values.contact_name,
                  contact_email: values.contact_email,
                  nombre: values.nombre,
                  external_code: values.external_code,
                  area_de_conocimiento: values.area_de_conocimiento.value,
                  especialidad_de_conocimiento:
                    values.especialidad_de_conocimiento.value,
                  gran_area_de_conocimiento:
                    values.gran_area_de_conocimiento.value,
                  ciudad: values.city.value,
                  dependencie_type:
                    values.dependencie_value?.selectedActor?.type?.id || null,
                  dependencie_value: values.dependencie_value?.value || null,
                  phone: values.phone,
                  descripcion: values.description,
                  sector: values.sector || "",
                  services: values.services || "",
                  source: values.source,
                  update_date: new Date(values.update_date).toISOString(),
                  issue_date: new Date(values.issue_date).toISOString(),
                  current_date: new Date(values.current_date).toISOString(),
                  state: values.state.value,
                  actor_type: Props.actorType.id,
                  recognized_min: values?.recognized_min.value,
                  features: values.features,
                  city: values.city.value,
                  url: values.url,
                })
              );

              Props.onCreated();
            });
          }}
          name="newCommon"
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col xs={24} sm={12} md={8} lg={18}>
              <Form.Item
                label="Nombre"
                name="nombre"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el nombre de la universidad",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                label="Código"
                name="external_code"
                rules={[
                  { required: true, message: "Por favor ingrese el codigo." },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Nombre de contacto"
                name="contact_name"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el nombre del contacto",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Teléfono"
                name="phone"
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: "Por favor ingrese el numero teléfonico",
                  },
                ]}
              >
                <MaskedInput mask={"+57(000)000-0000"} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Email de contacto"
                name="contact_email"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el email de contacto",
                  },
                  {
                    type: "email",
                    message: "Por favor ingrese un email válido",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={24}>
              <Form.Item
                label="Entidad dependiente"
                name="dependencie_value"
                rules={[{ type: "object" }]}
              >
                <SelectEntityDependency
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      console.log("selected", selected);
                      setState(selected);
                      form.setFieldValue("dependencie_value", selected);
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Departamento"
                name="state"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectStates
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      setState(selected);
                      form.setFieldValue("state", selected);
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Ciudad"
                name="city"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectCities
                  selectedState={state?.value}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      form.setFieldValue("city", selected);
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Area general"
                name="area_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeArea
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  defaultValue="Área general"
                  onChange={(selected: any) => {
                    form.setFieldValue("area_de_conocimiento", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Área específica"
                name="especialidad_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeSpecialty
                  onClear={() => {}}
                  defaultValue="Área específicass"
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue(
                      "especialidad_de_conocimiento",
                      selected
                    );
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Gran área del conocimiento"
                name="gran_area_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeGran
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  defaultValue="Gran Área de conocimiento"
                  onChange={(selected: any) => {
                    form.setFieldValue("gran_area_de_conocimiento", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Descripción"
                name="description"
                rules={[{ type: "string" }]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Sector"
                name="sector"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Servicios ofrecidos"
                name="services"
                rules={[{ type: "string" }]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={8}>
              <Form.Item
                label="Acreditada de alta calidad."
                name="is_accredited"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectAccredited
                  onClear={() => {}}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      form.setFieldValue("is_accredited", selected);
                    }
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={6} lg={8}>
              <Form.Item
                label="Reconocimiento min."
                name="recognized_min"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectRecognition
                  onClear={() => {}}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      form.setFieldValue("recognized_min", selected);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Fuente"
                name="source"
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Características"
                name="features"
                rules={[{ type: "string" }]}
              >
                <TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Fecha de expedición"
                name="issue_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  placeholder="Fecha de expedición"
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("issue_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Vigencia"
                name="current_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("current_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Vigencia"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Última actualización"
                name="update_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("update_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Última actualización"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Página web"
                name="url"
                rules={[{ type: "url" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ span: 24 }}>
            <Button
              loading={createdCommonState?.isLoading}
              type="primary"
              size={"large"}
              block
              htmlType="submit"
            >
              Agregar {`${Props?.actorType?.actor || ""}`}
            </Button>
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};

export default NewCommonModal;
